import Parse from 'parse';

const GroupPostsModule = {
  namespaced: true,
  state: {
    posts: [],
    groupPosts: {},
    currentGroup: null,
    pinnedPosts: [],
    limit: 15,
    offset: 15,
    lastFetched: null,
    imageFile: null,
  },
  mutations: {
    setPosts(state, posts) {
      state.posts = posts;
    },
    setCurrentGroup(state, currentGroup) {
      state.currentGroup = currentGroup;
    },
    setGroupPosts(state, groupPosts) {
      state.groupPosts = groupPosts;
    },
    setImageFile(state, file) {
      state.imageFile = file;
    },
    setPinnedPosts(state, pinnedPosts) {
      state.pinnedPosts = pinnedPosts;
    },
    increaseOffset(state) {
      state.offset = state.offset + state.limit;
    },
    updatePost(state, { post, type = 'posts' }) {
      const posts = state[type];

      const p = posts.filter((el) => el.id === post.id)[0];

      if (p) {
        const index = posts.indexOf(p);
        posts[index] = post;
        state[type] = posts;
      }
    },
    removePost(state, post) {
      if (state.posts) {
        state.posts = state.posts.filter((el) => el.id !== post.id);
      }
      if (state.groupPosts) {
        state.groupPosts = state.groupPosts.filter((el) => el.id !== post.id);
      }
    },
    insertOwnPost(state, post) {
      state.posts.unshift(post);
    },
    insertNewPosts(state, posts) {
      for (let i = posts.length - 1; i >= 0; i--) {
        state.posts.unshift(posts[i]);
      }
    },
    addToPinned(state, post) {
      state.pinnedPosts.unshift(post);

      const index = state.posts.indexOf(post);
      state.posts.splice(index, 1);
    },
    removeFromPinned(state, post) {
      const index = state.pinnedPosts.indexOf(post);
      state.pinnedPosts.splice(index);
      state.posts.unshift(post);
    },
    setLastFetch(state, date) {
      state.lastFetched = date;
    },
  },
  actions: {
    async loadPosts({ commit, state }) {
      try {
        const query = new Parse.Query('Post');
        query.limit(state.limit);
        query.addDescending('createdAt');
        query.includeAll();
        query.containedIn('feessbookGroups', [state.currentGroup]);
        query.equalTo('isPinned', false);
        const posts = await query.find(null);
        commit('setLastFetch', new Date());
        commit('setPosts', posts);
      } catch (e) {
        commit('setPosts', []);
      }
    },
    async loadCurrentGroup({ commit }, id) {
      try {
        const currentGroup = await new Parse.Query('FeessbookGroup').get(id, null);
        commit('setCurrentGroup', currentGroup);
      } catch (e) {
        console.log(e);
      }
    },
    async loadMorePosts({ commit, state }) {
      try {
        const query = new Parse.Query('Post');
        query.addDescending('createdAt');
        query.includeAll();
        query.limit(state.limit);
        query.skip(state.offset);
        query.containedIn('feessbookGroups', [state.currentGroup]);
        query.equalTo('isPinned', false);
        const posts = await query.find(null);
        commit('setPosts', [...state.posts, ...posts]);
        commit('increaseOffset');
        return posts;
      } catch (e) {
        console.log(e);
      }
    },
    async loadPinnedPosts({ commit, state }) {
      try {
        const query = new Parse.Query('Post');
        query.equalTo('isPinned', true);
        query.containedIn('feessbookGroups', [state.currentGroup]);
        query.includeAll();
        const pinnedPosts = await query.find(null);
        commit('setPinnedPosts', pinnedPosts);
        return pinnedPosts;
      } catch (e) {
        commit('setPinnedPosts', null);
      }
    },
    async fetchNewPosts({ state, commit }) {
      try {
        const query = new Parse.Query('Post');
        query.addDescending('createdAt');
        query.includeAll();
        query.containedIn('feessbookGroups', [state.currentGroup]);
        query.equalTo('isPinned', false);
        query.notEqualTo('author', Parse.User.current());
        query.greaterThanOrEqualTo('createdAt', state.lastFetched);
        const posts = await query.find(null);
        commit('setLastFetch', new Date());
        commit('insertNewPosts', posts);
      } catch (e) {
        commit('insertNewPosts', []);
      }
    },
    deletePost({ commit }, post) {
      const query = new Parse.Query('Post');
      query.include('Comment');
      commit('removePost', post);
      query.get(post.id).then((entry) => {
        entry.destroy().then(() => {
          this.$router.go(-1);
        });
      });
    },
  },
  getters: {
    posts: (state) => state.posts,
    pinnedPosts: (state) => state.pinnedPosts,
    lastFetched: (state) => state.lastFetched,
    imageFile: (state) => state.imageFile,
    groupPosts: (state) => state.groupPosts,
    currentGroup: (state) => state.currentGroup,
  },
};
export default GroupPostsModule;
